import { sectionRenderer } from '@theme/section-renderer';

// Refresh cart-bearing sections even when a restored document is reported as a
// normal navigation. Section-cache bypass alone does not bypass browser caching.
let initialRefreshStarted = false;
function refreshRestoredCart(event) {
  const restore = event?.persisted || event?.type === 'popstate';
  if (initialRefreshStarted && !restore) return;
  initialRefreshStarted = true;
  const sectionIds = new Set(
    [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
  );
  try {
    sessionStorage.removeItem('cart-count');
  } catch (_) {
    // Cart refresh must also work when browser storage is unavailable.
  }
  for (const sectionId of sectionIds) {
    const url = new URL(window.location.href);
    url.searchParams.set('_ss_cart_refresh', String(Date.now()));
    sectionRenderer.renderSection(sectionId, { cache: false, url }).catch((error) => {
      console.warn('Unable to refresh cart after page restoration.', error);
    });
  }
}
window.addEventListener('pageshow', refreshRestoredCart);
window.addEventListener('popstate', refreshRestoredCart);
// Module scripts run after parsing, but may arrive after pageshow.
refreshRestoredCart();
